import React from "react";
import { BackButton, Button, SecondaryButton } from "../../components";
import warrantyImage from "../../assets/images/warranty.jpg";
import { useNavigate, NavigateFunction } from "react-router-dom";
import RouteNames from "../../routes/type";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../store/root-reducer";

function NoWarrantyFound() {
  const navigate: NavigateFunction = useNavigate();
  const planSerachTry = useSelector(
    (state: RootState) => state.user.planSerachTry
  );
  const { t } = useTranslation();

  const onRetry = () => {
    navigate(-1);
  };

  const onContactService = () => {
    navigate(`/${RouteNames.CONTACT_SERVICE}`);
  };

  return (
    <>
      <div className="px-4 ">
        <div className="mb-8 mt-6">
          <BackButton />
        </div>
        <div className="mb-8">
          <img src={warrantyImage} className="mx-auto" alt="" />
        </div>

        {planSerachTry >= 3 ? (
          <>
            <p className="text-[#5A5A5A] text-center">
              {t(
                "Unfortunately, we were note able to locate your contact with the information provided. Please contact service we are happy to help you."
              )}
            </p>
            <div className="mt-5">
              <Button
                className="text-white bg-blue-600"
                onClick={onContactService}
              >
                {t("Contact Service")}
              </Button>
            </div>
          </>
        ) : (
          <>
            <p className="text-[#5A5A5A] text-center">
              {t(
                "Unfortunately, we were note able to locate your contact with the information provided. Please click the button below to retry your search. Remember to use your original invoice/receipt contact information."
              )}
            </p>
            <div className="flex gap-2 mt-8">
              <SecondaryButton
                onClick={onRetry}
                className="text-blue-600 bg-blue-100 max-w-[180px] mx-auto"
              >
                {t("Try Again")}
              </SecondaryButton>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default NoWarrantyFound;
